import { environment } from '@env/environment';
import { BrandingData } from '@shared/models/account.model';

export const brandingUri = (domain: string) => {
  return {
    api: `api.${domain}`,
    web: `app.${domain}`,
    www: `www.${domain}`,
    poll: `poll.${domain}`,
    survey: `survey.${domain}`,
    report: `report.${domain}`,
    storage: `storage.${domain}`,
  };
};

export const brandedText = (text: string, branding: BrandingData) => {
  const isEsko = branding?.name === 'Esko';
  const brandedName = branding?.name || 'Zeffi';
  const brandedMailDomain = isEsko ? 'eskoaimail.com' : 'zeffimail.com';
  const brandedPath = isEsko ? '/esko' : '/zeffi';

  return (text || '')
    .replace(/_BRAND_/g, brandedName)
    .replace(/Zeffi/g, brandedName)
    .replace('/zeffi', brandedPath)
    .replace('zeffimail.com', brandedMailDomain);
};

export function isEskoHostname() {
  return !window.location.hostname.includes('zef');
}

export function brandedUrl(value: string) {
  return isEskoHostname() ? value.replace('zef.fi', 'esko.ai') : value;
}

export function publicUrl(): string {
  return isEskoHostname() ? 'https://esko.ai' : 'https://zef.fi';
}

export function wwwAddress(): string {
  const zeffiAddress = `https:${environment.wwwAddress}`;
  const eskoAddress = zeffiAddress.replace('zef.fi', 'esko.ai').replace('zeffi.dev', 'eskoai.dev');

  return isEskoHostname() ? eskoAddress : zeffiAddress;
}

export function webAddress(): string {
  const zeffiAddress = `https:${environment.webAddress}`;
  const eskoAddress = zeffiAddress.replace('zef.fi', 'esko.ai').replace('zeffi.dev', 'eskoai.dev');

  return isEskoHostname() ? eskoAddress : zeffiAddress;
}

export function pollAddress(): string {
  const zeffiAddress = `https:${environment.pollAddress}`;
  const eskoAddress = zeffiAddress.replace('zef.fi', 'esko.ai').replace('zeffi.dev', 'eskoai.dev');

  return isEskoHostname() ? eskoAddress : zeffiAddress;
}

export function surveyAddress(): string {
  const zeffiAddress = `https:${environment.surveyAddress}`;
  const eskoAddress = zeffiAddress.replace('zef.fi', 'esko.ai').replace('zeffi.dev', 'eskoai.dev');

  return isEskoHostname() ? eskoAddress : zeffiAddress;
}

export function brandedFavicon() {
  document.addEventListener('DOMContentLoaded', function () {
    const faviconTag = document.getElementById('favicon');
    const faviconPath = isEskoHostname() ? './assets/esko-favicon.ico' : './assets/zeffi-favicon.ico';

    document.title = isEskoHostname() ? document.title.replace('Zeffi', 'Esko') : document.title;

    if (faviconTag) {
      faviconTag.setAttribute('href', faviconPath);
    } else {
      const newFavicon = document.createElement('link');
      newFavicon.id = 'favicon';
      newFavicon.rel = 'icon';
      newFavicon.href = faviconPath;
      document.head.appendChild(newFavicon);
    }
  });
}
